import { Component, OnInit, Input } from "@angular/core";

enum TAG {
  Visita = 1,
  Retorno = 2,
  Tarefa = 3,
  Lembrete = 4,
  Evento = 5
}

@Component({
  selector: 'app-today-schedule',
  templateUrl: './today-schedule.component.html',
  styleUrls: ['./today-schedule.component.scss']
})
export class TodayScheduleComponent implements OnInit {

  @Input() schedule: any;

  public tag = '';
  public item = {
    temp: 1, // 1, 2, 3
    client: 'Cliente Charles Darwing rafael carvalho caetano',
    time: new Date().getDate(),
    tag: 2, // 1, 2, 3, 4, 5
  }

  ngOnInit(): void {
    this.tag = TAG[this.item.tag]
  }
}